var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
 * @Author: yejianfei
 * @Date: 2023-04-03 22:34:45
 * @LastEditors: yejianfei
 * @LastEditTime: 2023-04-28 14:05:15
 * @Description:
 * @Developer:
 */
import React from 'react';
import AdminPage from '../../components/antd/AdminPage';
import { Button, Card, Col, Form, Input, Row, Space } from 'antd';
import APITable from '../../components/antd/APITable';
import InputTags from '../../components/antd/APITags';
import WithRouter from '../../components/WithRouter';
import IconFont from '../../icons';
let AdminQuestionListPage = class AdminQuestionListPage extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {};
    }
    render() {
        return (React.createElement(AdminPage, { breadcrumbs: [{
                    label: '首页',
                    url: '../home'
                }, {
                    label: '问题管理',
                    url: '../questions'
                }] },
            React.createElement(Card, { style: { height: '100%' }, bodyStyle: { padding: 12, height: '100%' } },
                React.createElement(APITable, { bordered: true, tableLayout: 'fixed', loader: `/admin/questions/list/:page`, initialParams: {
                        page: 1,
                        size: 25,
                        filters: true
                    }, size: 'small', rowKey: 'id', pagination: { showSizeChanger: false }, columns: [{
                            title: '问题',
                            width: 200,
                            align: 'center',
                            dataIndex: 'title'
                        }, {
                            title: '选项',
                            width: 200,
                            align: 'center',
                            dataIndex: 'options',
                            render: (value) => (value === null || value === void 0 ? void 0 : value.join(',')) || ''
                        }, {
                            title: '操作',
                            dataIndex: 'operation',
                            align: 'center',
                            width: 200,
                            render: ((text, record, index, instance) => {
                                return (React.createElement(Space, null,
                                    React.createElement(Button, { type: "link", onClick: () => instance.modal(record.id) }, "\u7F16\u8F91"),
                                    React.createElement(Button, { danger: true, type: "link", onClick: () => instance.delete(record.id) }, "\u5220\u9664")));
                            })
                        }], search: {
                        children: (table) => {
                            return (React.createElement(Row, null,
                                React.createElement(Col, { span: 8 },
                                    React.createElement(Form.Item, { name: ['keywords'] },
                                        React.createElement(Input.Search, { placeholder: '\u8F93\u5165\u95EE\u9898\u68C0\u7D22', allowClear: true, enterButton: true, onSearch: () => table.search() }))),
                                React.createElement(Col, { flex: 1 },
                                    React.createElement(Row, { justify: 'end' },
                                        React.createElement(Space, null,
                                            React.createElement(Form.Item, null,
                                                React.createElement(Button, { onClick: () => this.props.route.navigate('form'), icon: React.createElement(IconFont, { type: 'icon-questions-add' }) })))))));
                        }
                    }, form: {
                        title: '问题',
                        action: '/admin/questions',
                        loader: '/admin/questions/:id',
                        name: 'question-form',
                        initialValues: {
                            options: []
                        },
                        onLoaded: (values) => __awaiter(this, void 0, void 0, function* () { return (Object.assign(Object.assign({}, values), { password: Date.now() })); }),
                        children: (values) => (React.createElement(React.Fragment, null,
                            React.createElement(Form.Item, { label: '\u95EE\u9898', labelCol: { span: 5 }, name: ['title'], rules: [{ required: true, message: '请输入问题' }] },
                                React.createElement(Input, { placeholder: '\u8BF7\u8F93\u5165\u95EE\u9898' })),
                            React.createElement(Form.Item, { label: '\u9009\u9879', labelCol: { span: 5 }, name: ['options'], rules: [{ required: true, message: '请输入选项' }] },
                                React.createElement(InputTags, null))))
                    } }))));
    }
};
AdminQuestionListPage = __decorate([
    WithRouter()
], AdminQuestionListPage);
export default AdminQuestionListPage;
